/**
 * useBoardPositionHelpers - position helpers for drag/context menu
 * Extracted from BoardV3.tsx for readability
 */

import { useCallback } from 'react';
import { getMaxRow } from '../utils/boardHelpers';

export function useBoardPositionHelpers(
  columns: string[],
  columnYOffsets: Record<string, number>,
  rowAssignments: Record<string, Map<string, number>>,
  rowHeight: number,
  headerHeight: number,
  columnLabelWidth: number,
  dayWidth: number,
) {
  const getColumnFromY = useCallback((y: number): string | null => {
    const relativeY = y - headerHeight;
    if (relativeY < 0) return null;

    for (let i = 0; i < columns.length; i++) {
      const column = columns[i];
      const yOffset = columnYOffsets[column] ?? 0;
      const rowCount = Math.max(1, getMaxRow(rowAssignments[column]) + 1);
      const columnHeight = rowCount * rowHeight + 8;

      if (relativeY >= yOffset && relativeY < yOffset + columnHeight) {
        return column;
      }
    }
    return columns[columns.length - 1] || null;
  }, [columns, columnYOffsets, rowAssignments, rowHeight, headerHeight]);

  const getDayFromX = useCallback((x: number): number => {
    const relativeX = x - columnLabelWidth;
    const day = Math.floor(relativeX / dayWidth);
    return Math.max(0, day);
  }, [columnLabelWidth, dayWidth]);

  return { getColumnFromY, getDayFromX };
}
